import {
  FunctionComponent,
  PropsWithChildren,
  createContext,
  useContext,
  useEffect,
  useState,
} from 'react';

export type SettingsContext = {
  getSetting: (name: string, defaultValue?: string) => string;
};
const SettingsContext = createContext<SettingsContext>({
  getSetting: () => {
    console.error('No provider');
    return '';
  },
});

export const useSettings = () => {
  return useContext(SettingsContext);
};

const defaults: Record<string, string> = {
  AUTH_DOMAIN: 'auth.simpallo.app',
  AUTH_CLIENT_ID: 'aUnCnbG97PZSJFkFd3yeTsV6cmfYtv7o',
  GRAPHQL_ENDPOINT: '/graphql',
  GRAPHQL_ENDPOINT_CLONE: '/cloner/graphql',
};

export const SettingsProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const [localSetting, setLocalSettings] = useState<Record<string, string>>({});
  const getSetting = (name: string, defaultValue?: string): string => {
    if (localSetting && typeof localSetting?.[name] === 'string') {
      return localSetting?.[name];
    }
    const viteKey = `VITE_${name}`;
    if (typeof import.meta.env?.[viteKey] === 'string' && import.meta.env[viteKey] !== '') {
      return import.meta.env[viteKey];
    }
    if (window)
      if (typeof window?.process?.env?.[name] === 'string') {
        return window?.process?.env?.[name] as string;
      }
    if (defaultValue) {
      return defaultValue;
    }
    if (typeof defaults?.[name] === 'string') {
      return defaults?.[name];
    }
    return '';
  };
  useEffect(() => {
    const appSettings = sessionStorage.getItem('APP_SETTINGS');
    try {
      if (appSettings) {
        const parsedSettings = JSON.parse(appSettings);
        if (parsedSettings) {
          setLocalSettings(parsedSettings);
        }
      }
    } catch {}
  }, []);
  return (
    <SettingsContext.Provider value={{ getSetting }}>
      {children}
    </SettingsContext.Provider>
  );
};
